export function formatarMoeda(valor: number): string {
  try {
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });
  } catch (error) {
    console.error("Erro ao formatar moeda:", error);
    return `TC ${valor.toFixed(2).replace('.', ',')}`;
  }
}